import { render } from "./Localizations.vue?vue&type=template&id=5bc12029"
import script from "./Localizations.vue?vue&type=script&lang=js"
export * from "./Localizations.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Localizations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bc12029"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bc12029', __exports__)) {
    console.log('reload')
    api.reload('5bc12029', __exports__)
  }
  
  module.hot.accept("./Localizations.vue?vue&type=template&id=5bc12029", () => {
    console.log('re-render')
    api.rerender('5bc12029', render)
  })

}


export default __exports__